<template>
  <div>
    <!-- Modal Top Up Whitelisted -->
    <BModal
      id="modal-topup-whitelisted"
      ref="modal-topup-whitelisted"
      no-stacking
      centered
      hide-footer
      hide-header
      hide-header-close
      no-close-on-backdrop
      no-close-on-esc
      size="md"
    >
      <BRow class="justify-center my-1 flex flex-column">
        <BCol
          class="flex flex-col text-center gap-2 justify-content-center mb-2"
        >
          <strong class="text-black text-xl">
            Top Up Whitelisted
          </strong>
          <span class="text-black text-md">
            Yuk, top up akun Whitelisted pakai Kompay—akses istimewa langsung
            aktif
          </span>
        </BCol>
        <BCol class="justify-content-center">
          <ValidationObserver #default="{ invalid }">
            <div
              class="mb-1 border border-gray-200 rounded-md py-2 ps-4 flex justify-between items-center"
            >
              <div class="flex flex-col">
                <label
                  class="font-semibold text-md block text-black"
                >Saldo Kompay</label>
                <div class="text-2xl font-bold text-black">
                  {{ IDR(saldo) }}
                </div>
              </div>
            </div>

            <BFormGroup label-for="platform">
              <template #label>
                <div class="flex justify-between mt-2">
                  <div class="text-black flex items-center">
                    <strong
                      class="text-md font-semibold"
                    >Pilih Platform
                    </strong>
                    <strong class="text-primary">*</strong>
                  </div>
                </div>
              </template>
              <ValidationProvider
                v-slot="{ errors }"
                name="Platform"
                rules="required"
              >
                <VSelect
                  v-model="selectedPlatform"
                  :options="platformOptions"
                  label="platform"
                  placeholder="Pilih platform disini"
                  :disabled="whitelistedAccounts.length < 1"
                >
                  <template #no-options>
                    Tidak ada platform
                  </template>
                  <template #option="option">
                    <div class="flex items-center gap-2">
                      <img
                        :src="option.image"
                        alt="Platform icon"
                        width="20"
                        height="20"
                      >
                      <span class="text-black">{{ option.name }}</span>
                    </div>
                  </template>
                  <template #selected-option="option">
                    <div class="flex items-center gap-2">
                      <img
                        :src="option.image"
                        alt="Platform icon"
                        width="20"
                        height="20"
                      >
                      <span class="text-black">{{ option.name }}</span>
                    </div>
                  </template>
                </VSelect>
                <small class="text-danger">{{ errors[0] }}</small>
              </ValidationProvider>
            </BFormGroup>

            <BFormGroup label-for="akun-iklan">
              <template #label>
                <div class="flex justify-between mt-2">
                  <div class="text-black flex items-center">
                    <strong
                      class="text-md font-semibold"
                    >Pilih Akun Iklan Whitelisted
                    </strong>
                    <strong class="text-primary">*</strong>
                  </div>
                </div>
              </template>
              <ValidationProvider
                v-slot="{ errors }"
                name="Akun"
                rules="required"
              >
                <VSelect
                  v-model="selectedAccount"
                  :options="filteredWhitelistedAccounts"
                  label="name"
                  placeholder="Pilih akun iklan whitelisted disini"
                  :disabled="!selectedPlatform"
                >
                  <template #no-options>
                    Tidak ada akun
                  </template>
                  <template #option="{ name }">
                    <div class="flex items-center gap-2">
                      <span class="text-black">{{ name }}</span>
                    </div>
                  </template>
                </VSelect>
                <small class="text-danger">{{ errors[0] }}</small>
              </ValidationProvider>
            </BFormGroup>

            <BFormGroup label-for="nominal">
              <template #label>
                <div class="flex justify-between">
                  <div class="text-black flex items-center">
                    <strong class="text-md font-semibold">Nominal</strong>
                    <strong class="text-primary">*</strong>
                  </div>
                </div>
              </template>
              <ValidationProvider
                v-slot="{ errors }"
                name="Nominal"
                :rules="{
                  required: 'Nominal harus diisi',
                  min_value: MIN_BALANCE,
                }"
                label-for="nominal"
                label-slot="label-nominal"
              >
                <BFormInput
                  v-model="nominal"
                  type="text"
                  maxlength="11"
                  placeholder="Masukkan nominal disini"
                  @keypress="isNumber($event)"
                  @input="formatNominal"
                />
                <small class="text-danger">{{ errors[0] }}</small>
                <small
                  v-if="!minimalSaldo || totalGreaterThanSaldo"
                  class="flex flex-row items-center gap-2 text-danger mt-[6px]"
                >
                  <img
                    src="https://storage.googleapis.com/komerce/assets/komerce-icon/Orange/danger.svg"
                    alt="danger"
                    width="16"
                    height="16"
                  >
                  <p class="m-0 text-xs">
                    Nominal Saldo Kompay kurang, Silahkan
                    <a
                      class="!text-[#08A0F7] !underline"
                      @click.prevent="
                        $router.push({ name: 'dashboard-komship' })
                      "
                    >topup saldo kompaymu</a>
                  </p>
                </small>
              </ValidationProvider>

              <div
                :class="
                  `grid grid-cols-${
                    nominalOptions.length % 2 === 0 ? 2 : 1
                  } md:grid-cols-${nominalOptions.length} gap-2 mt-1`
                "
              >
                <BButton
                  v-for="(amount, index) in nominalOptions"
                  :key="index"
                  :variant="
                    selectedNominal === amount ? 'primary' : 'outline-secondary'
                  "
                  class="rounded-lg p-1"
                  @click="selectNominal(amount)"
                >
                  {{ IDR(amount) }}
                </BButton>
              </div>
            </BFormGroup>

            <div>
              <!-- Batas Minimal Saldo Ideal -->
              <div
                v-if="showIdealBalance"
                class="bg-[#FFEDED] p-1 rounded-lg mb-2"
              >
                <div class="d-flex">
                  <span
                    class="k-info-circle-1 text-danger font-bold align-content-center mr-1 text-xl"
                  />
                  <div
                    class="font-medium text-black text-[14px] align-content-center"
                  >
                    Batas Minimal Saldo Ideal :
                    <b>
                      {{ IDR(idealBalance) }}
                    </b>
                  </div>
                </div>
                <div class="mb-1">
                  Saldo ideal diterapkan untuk menghindari saldo minus.
                  <a
                    class="text-[#08A0F7] underline"
                    href="https://bantuan.komerce.id/id/article/saldo-ideal-komship-7dn9vp/?bust=1724821138075"
                    target="_blank"
                  >Pelajari lebih lanjut</a>
                </div>
                <div class="p-1 bg-[#FFFFFF] rounded-lg">
                  <div class="flex">
                    <span
                      class="k-message-question font-bold align-content-center mr-1 text-lg"
                    />
                    <div class="font-medium content-center">
                      Darimana Saldo Ideal berasal?
                    </div>
                  </div>
                  <span>Potensi Pendapatan Order Dikirim
                    <b>{{ IDR(incomeOrderPotential) }}</b>
                    - Ongkir Retur Ketika Sampai
                    <b>{{ IDR(potencyRetur) }}</b>
                    - Resiko Ongkir Menjadi Retur
                    <b>{{ IDR(riskRetur) }}</b>
                    = Saldo Ideal
                    <b class="text-primary">{{ IDR(idealBalance) }}</b>
                  </span>
                </div>
              </div>

              <!-- Perhitungan Total -->
              <div
                v-if="showTotalCalculation"
                class="mt-2"
              >
                <div class="flex justify-between text-black mb-1">
                  <div>Nominal top up</div>
                  <div>{{ IDR(getNominalValue) }}</div>
                </div>
                <div class="flex justify-between text-black mb-1">
                  <div>Top up fee ({{ selectedAccount.fee_topup }} %)</div>
                </div>
                <div class="flex justify-between text-black mb-1 pl-1">
                  <div>• Fee</div>
                  <div>{{ IDR(getFee) }}</div>
                </div>
                <div class="flex justify-between text-black mb-1 pl-1">
                  <div>• PPN</div>
                  <div>{{ IDR(getPPN) }}</div>
                </div>
                <hr class="border-[#C2C2C2]">
                <div class="flex justify-between font-medium text-black">
                  <div class="text-lg flex items-center">
                    Total Pembayaran
                    <img
                      id="totalPaymentInfo"
                      src="https://storage.googleapis.com/komerce/assets/icons/info-circle.svg"
                      alt="info"
                      width="16"
                      height="16"
                      class="ml-1"
                    >
                    <b-popover
                      target="totalPaymentInfo"
                      triggers="hover"
                      placement="top"
                      custom-class="!bg-[#333333]"
                    >
                      <h1 class="text-base font-semibold text-white">
                        Total Pembayaran
                      </h1>
                      <span
                        class="text-white"
                      >Nominal Top Up ditambah dengan Fee Top Up</span>
                    </b-popover>
                  </div>
                  <div class="text-lg font-bold">
                    {{ IDR(getTotal) }}
                  </div>
                </div>
              </div>

              <div class="mt-2 flex cols cols-12 gap-2">
                <BButton
                  variant="outline-primary"
                  class="rounded-lg px-4 w-full cols-6"
                  @click="closeModal"
                >
                  Batal
                </BButton>

                <BButton
                  :variant="
                    invalid ||
                      !getNominalValue ||
                      !minimalSaldo ||
                      totalGreaterThanSaldo ||
                      showIdealBalance ||
                      loading
                      ? 'secondary'
                      : 'primary'
                  "
                  class="rounded-lg px-4 bg-[#FF5C00] border-[#FF5C00] w-full cols-6"
                  :disabled="
                    invalid ||
                      !getNominalValue ||
                      !minimalSaldo ||
                      totalGreaterThanSaldo ||
                      showIdealBalance ||
                      loading
                  "
                  @click="$bvModal.show('modal-working-hours-notification')"
                >
                  Top Up Sekarang
                </BButton>
              </div>
            </div>
          </ValidationObserver>
        </BCol>
      </BRow>
    </BModal>

    <!-- Modal Confirmation Working Hour -->
    <BModal
      id="modal-working-hours-notification"
      ref="modal-working-hours-notification"
      centered
      hide-header
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
      size="md"
    >
      <div
        class="position-absolute"
        style="right: 15px; top: 15px;"
      >
        <feather-icon
          icon="XIcon"
          class="cursor-pointer"
          @click="closeWorkingHoursModal(); resetCondition()"
        />
      </div>

      <BRow class="my-2">
        <BCol
          cols="12"
          class="text-center mb-2"
        >
          <div class="d-flex justify-content-center mb-2">
            <img
              src="https://storage.googleapis.com/komerce/assets/icons/warning.svg"
              alt="Warning"
              width="72"
              height="72"
            >
          </div>
          <span class="text-black text-base mb-0">
            Permintaan akan kami proses pada jam kerja
            <b>(Senin–Jumat, 08.00–20.00)</b>. Jika Anda setuju, klik
            <b>Lanjutkan</b> untuk melanjutkan proses.
          </span>
        </BCol>

        <BCol cols="12">
          <div class="d-flex gap-2">
            <BButton
              variant="outline-primary"
              class="rounded-lg w-50"
              @click="
                $bvModal.show('modal-topup-whitelisted'),
                closeWorkingHoursModal()
              "
            >
              Batal
            </BButton>
            <BButton
              variant="primary"
              class="rounded-lg w-50 bg-[#FF5C00] border-[#FF5C00]"
              @click="continueTopup"
            >
              Ya, Lanjutkan
            </BButton>
          </div>
        </BCol>
      </BRow>
    </BModal>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'
import { IDR } from '@/libs/currency'
import { newAxiosIns } from '@/libs/axios'
import VSelect from 'vue-select'
import { mapState } from 'vuex'
import { isNumber } from '@/libs/helpers'
import moment from 'moment'

extend('min_value', {
  validate(value, { min_value }) {
    const numValue = parseFloat(value.replace(/[^0-9,-]+/g, ''))
    return numValue >= min_value
  },
  params: ['min_value'],
  message: (_, { min_value }) => `Minimal topup ${IDR(min_value)}`,
})

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    VSelect,
  },
  props: {
    whitelistedAccounts: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      IDR,
      isNumber,
      nominal: '',
      BASE_MIN_BALANCE: 300000,
      TIKTOK_MIN_BALANCE: 500000,
      BASE_NOMINAL_OPTIONS: [300000, 500000, 1000000, 1500000],
      selectedNominal: null,
      selectedAccount: null,
      selectedPlatform: null,
      allPlatformOptions: [
        {
          name: 'Meta',
          image: 'https://storage.googleapis.com/komerce/komads-meta/meta.svg',
        },
        {
          name: 'Google',
          image:
            'https://storage.googleapis.com/komerce/komads-meta/google.svg',
        },
        {
          name: 'Tiktok',
          image:
            'https://storage.googleapis.com/komerce/komads-meta/tiktod.svg',
        },
      ],
      notes: '',
      idealBalance: 0,
      incomeOrderPotential: 0,
      potencyRetur: 0,
      riskRetur: 0,
      loading: false,
      tax: 0.11,

      whitelistInfo: null,
      totalSpendPlatform: [],
    }
  },
  computed: {
    ...mapState('dashboard', ['profile']),
    ...mapState('saldo', ['saldo']),
    /**
     * Get minimum topup amount based on selected platform
     * @returns {number} Minimum topup amount (500000 for TikTok, 300000 for others)
     */
    MIN_BALANCE() {
      return this.isTiktokPlatform
        ? this.TIKTOK_MIN_BALANCE
        : this.BASE_MIN_BALANCE
    },
    /**
     * Get nominal options based on selected platform
     * For TikTok, removes the first option (300000)
     * @returns {Array<number>} Array of nominal options
     */
    nominalOptions() {
      if (this.isTiktokPlatform) {
        return this.BASE_NOMINAL_OPTIONS.slice(1)
      }
      return this.BASE_NOMINAL_OPTIONS
    },
    /**
     * Check if selected platform is TikTok
     * @returns {boolean} True if selected platform is TikTok
     */
    isTiktokPlatform() {
      return this.selectedPlatform?.name?.toLowerCase() === 'tiktok'
    },
    /**
     * Get platform options based on total spend platform
     * @returns {Array} Array of platform options that have accepted status and valid subscription
     */
    platformOptions() {
      if (!this.totalSpendPlatform?.length) {
        return this.allPlatformOptions
      }

      const today = moment()

      const validPlatformNames = new Set()

      this.totalSpendPlatform.forEach(platform => {
        const isAccepted = platform.account_request_status === 'accepted'
        const isActive = !platform.expired_at || today.isSameOrBefore(platform.expired_at, 'day')

        if (isAccepted && isActive) {
          validPlatformNames.add(platform.platform_name.toLowerCase())
        }
      })

      return this.allPlatformOptions.filter(option => validPlatformNames.has(option.name.toLowerCase()))
    },

    /**
     * Filter whitelisted accounts based on selected platform
     * @returns {Array} Array of whitelisted accounts that match the selected platform
     */
    filteredWhitelistedAccounts() {
      if (!this.selectedPlatform) return []
      return this.whitelistedAccounts.filter(
        account => account.platform_name === this.selectedPlatform.name.toLowerCase(),
      )
    },
    getNominalValue() {
      return Number(this.nominal.replace(/\D/g, ''))
    },
    fee_topup() {
      if (!this.selectedAccount) return 0

      return this.selectedAccount.fee_topup / 100
    },
    getPPN() {
      // Calculate PPN based on tax rate, round to nearest integer
      const amountTax = Math.round(this.getNominalValue * this.fee_topup)

      // Multiply PPN with tax rate, round to nearest integer
      return Math.round(amountTax * this.tax)
    },
    getFee() {
      // Calculate fee based on tax rate, round to nearest integer
      const amountFee = Math.round(this.getNominalValue * this.fee_topup)

      // Subtract PPN from fee, round to nearest integer
      return amountFee - this.getPPN
    },
    getTotal() {
      return Math.round(this.getNominalValue + this.getFee + this.getPPN)
    },
    /**
     * Checks if the current saldo is greater than or equal to the minimum required saldo.
     * The minimum required saldo is calculated as 300,000 plus an additional percentage fee
     * based on the `fee_topup` value of the first whitelisted account.
     *
     * @returns {boolean} True if the saldo meets or exceeds the minimum required amount, otherwise false.
     */
    minimalSaldo() {
      return this.saldo >= this.MIN_BALANCE + this.MIN_BALANCE * this.fee_topup
    },
    totalGreaterThanSaldo() {
      return this.getTotal > this.saldo
    },

    /**
     * Checks if the account balance needs to be topped up to reach the ideal balance
     * @computed
     * @returns {boolean} Returns true if all conditions are met:
     * 1. Current balance (saldo) is at least minimalSaldo
     * 2. Total transaction amount does not exceed current balance
     * 3. Remaining balance after transaction would be less than ideal balance
     * 4. User is a Komship user (is_komship flag is true)
     * 5. Ideal balance target is greater than 0
     * 6. An account is selected
     */
    showIdealBalance() {
      return (
        this.minimalSaldo
        && this.getTotal <= this.saldo
        && this.saldo - this.getTotal < this.idealBalance
        && this.profile.is_komship === 1
        && this.idealBalance > 0
        && this.selectedAccount
      )
    },
    showTotalCalculation() {
      return this.getNominalValue > 0 && this.selectedAccount
    },
  },
  watch: {
    /**
     * Watch for platform changes to reset dependent fields
     * Resets account selection and nominal when platform changes
     */
    selectedPlatform() {
      this.selectedAccount = null
      this.resetNominalOnPlatformChange()
    },
  },
  async mounted() {
    await this.getWhitelistInfo()
    await this.checkIdealBalance()
    this.$store.dispatch('saldo/getBalanceSummary')
  },
  methods: {
    /**
     * Reset all form fields to initial state
     */
    resetCondition() {
      this.nominal = ''
      this.selectedAccount = null
      this.selectedPlatform = null
      this.notes = ''
      this.selectedNominal = null
    },
    /**
     * Reset nominal field when platform changes
     * Clears nominal if current value is less than new minimum topup
     */
    resetNominalOnPlatformChange() {
      const currentNominalValue = this.getNominalValue
      if (currentNominalValue > 0 && currentNominalValue < this.MIN_BALANCE) {
        this.nominal = ''
        this.selectedNominal = null
      }
    },
    formatNumber(value) {
      // eslint-disable-next-line radix
      const result = parseInt(value.replace(/[^0-9]/g, ''))
      return result
    },
    formatNominal() {
      const value = this.nominal.replace(/\D/g, '')
      this.nominal = value ? value.replace(/\B(?=(\d{3})+(?!\d))/g, '.') : ''

      // Check if the current value matches any of the nominal options
      const currentValue = parseInt(value, 10)
      const matchingOption = this.nominalOptions.find(
        option => option === currentValue,
      )
      this.selectedNominal = matchingOption || null
    },
    selectNominal(amount) {
      this.selectedNominal = amount
      this.nominal = amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },
    closeModal() {
      this.resetCondition()
      this.$bvModal.hide('modal-topup-whitelisted')
    },

    async checkIdealBalance() {
      if (this.profile.is_komship === 1) {
        try {
          const response = await newAxiosIns.get(
            `/komship/api/v1/admin/partner-consumables/balance-analitycs/${this.profile.partner_id}`,
          )
          const { data } = response.data
          this.idealBalance = data.ideal_balance
          this.incomeOrderPotential = data.income_order_potential
          this.potencyRetur = data.ongkir_retur_on_finished
          this.riskRetur = data.ongkir_risk_become_retur
        } catch (error) {
          console.log(error)
        }
      }
    },

    /**
     * Get whitelist info for the current month from the API
     *
     * @returns {void}
     * @throws {Error}
     */
    async getWhitelistInfo() {
      try {
        const response = await newAxiosIns.get(
          '/komads/api/v1/partners/whitelist_info',
          {
            params: {
              month: moment().format('MM-YYYY'),
            },
          },
        )
        const { data } = response.data
        this.whitelistInfo = data
        this.totalSpendPlatform = data.total_spend_platform
      } catch (error) {
        console.warn(error)
      }
    },

    /**
     * Close working hours notification modal
     */
    closeWorkingHoursModal() {
      this.$bvModal.hide('modal-working-hours-notification')
    },

    /**
     * Continue with topup after acknowledging working hours notification
     */
    continueTopup() {
      this.closeWorkingHoursModal()
      this.processTopup()
    },

    /**
     * Process the actual topup transaction
     */
    async processTopup() {
      this.loading = true
      try {
        const response = await newAxiosIns.post(
          '/komads/api/v1/whitelist_accounts/topup',
          {
            amount_topup: this.getNominalValue,
            amount_fee: this.getFee,
            amount_tax: this.getPPN,
            whitelist_account_id: this.selectedAccount.id,
            notes: this.notes,
          },
        )

        // Get data history topup
        const postMessage = { type: 'GET_LIST_HISTORY_TOPUP' }
        const iframe = document.querySelector('#whitelisted-komads')
        if (iframe) iframe.contentWindow.postMessage(postMessage, '*')

        this.$store.dispatch('saldo/getBalanceSummary')

        this.$toast_success({ message: 'Top up berhasil' })

        const { data } = response.data
        const transactionId = data.id
        this.$emit('topupSuccess', transactionId)

        this.closeModal()
      } catch (error) {
        const errorKey = error.response.data.meta.errors[0].key

        const errorMessageServer = error.response.data.meta.message

        const ERROR_MESSAGE_MAP = {
          invalid_amount:
            'Terjadi kesalahan saat melakukan transaksi saldo Komads Whitelisted. Silahkan coba dengan nominal yang berbeda atau hubungi CS',
          minimal_topup_not_reached:
            'Transaksi gagal karena saldo Kompay tidak mencukupi. Harap cek kembali saldo Kompay saat ini.',
          account_not_found:
            'Akun tidak ditemukan, silahkan hubungi customer service kami',
          fee_topup_not_found:
            'Biaya top up tidak ditemukan, silahkan hubungi customer service kami',
        }

        const userFriendlyMessage = ERROR_MESSAGE_MAP[errorKey]
          || errorMessageServer
          || 'Terjadi kesalahan pada sistem. Coba lagi beberapa saat atau hubungi CS.'

        this.$toast_error({ message: userFriendlyMessage })
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style lang="css" scoped>
.border {
  border-color: #e2e2e2 !important;
}
</style>
